import { useParams } from "react-router-dom";
import { RequestRecordsProvider } from "../request-records/context/RequestRecordsContext";
import RequestRecordsLayout from "../request-records/components/RequestRecordsLayout";

export default function RequestRecordsPage() {
  const { slug } = useParams<{ slug: string }>();
  return (
    <RequestRecordsProvider slug={slug}>
      <RequestRecordsLayout />
    </RequestRecordsProvider>
  );
}

